import React from "react";
import { NavLink } from "react-router-dom";

import Bars from './pages/images/icons/bar.png';
import {Navhead} from './js/script.js'

function Navbar() {
  return (
    <nav className="navbar" id="smallnav">
      <ul>
        <li id="nav" onClick={Navhead}><img src={Bars}></img></li>
        <li>
          <NavLink exact to="/" activeClassName="x">
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/about" activeClassName="x">
            About
          </NavLink>
        </li>
        <li>
          <NavLink to="/event" activeClassName="x">
            Event
          </NavLink>
        </li>
        <li>
          <NavLink to="/locations" activeClassName="x">
            Locations
          </NavLink>
        </li>
        <li id="contact">
          <NavLink to="/contact" activeClassName="x">
            Contact Us
          </NavLink>
        </li>
        <NavLink to="/contact" className="Title">
          <li> Contact Us </li>
        </NavLink>
      </ul>
    </nav>
  );
}

export default Navbar;